<template>
  <div class="picker">
       <van-popup @closed="onCancel" v-model="showPop" position="bottom" :style="{ height: '40%' }">
           <van-area
                :area-list="areaList"
                :value="value"
                @confirm="onConfirm"
                @cancel="onCancel"
                :title="title"
            />
       </van-popup>
  </div>
</template>

<script>
import { Popup, Area } from 'vant'
import api from '@/utils/api'
export default {
    components: {
        [Popup.name]: Popup,
        [Area.name]: Area
    },
    props: {
        title: {
            type: String,
            default: '请选择地区'
        },
        showArea: {
            type: Boolean,
            default: false
        },
        value: {
            type: String,
            default: ''
        }
    },
    watch: {
        showArea(newVal) {
            this.showPop = newVal
        }
    },
    data() {
        return {
            showPop: false,
            areaList: []
        }
    },
    created() {
        this.getAreaList()
    },
    methods: {
        onCancel() {
            this.showPop = false
            this.$emit('cancel')
        },
        onConfirm(picker) {
            this.showPop = false
            this.$emit('confirm', picker)
        },
        getAreaList() {
            api.getAreaList().then(res => {
                if (res.code === 0) {
                    this.areaList = res.data
                    this.$emit('areaLoad', true)
                }
            })
        }
    }
}
</script>
<style>
    .picker .van-picker__cancel,.van-picker__confirm
    {
        width: auto!important;
    }
</style>
